/**
 * One generation run (Spec § 3.3): `PENDING → GENERATING → READY | FAILED`.
 * `DISCARDED` only ends a post-save regeneration the reviewer dropped (S6):
 * the saved entry stays, the dictation stays `SAVED`, the card shows
 * „Gespeichert" again. Before the first save a discard ends the whole
 * dictation instead, so a draft of an unsaved dictation never gets it.
 */
export var AiDraftStatus;
(function (AiDraftStatus) {
    AiDraftStatus["PENDING"] = "PENDING";
    AiDraftStatus["GENERATING"] = "GENERATING";
    AiDraftStatus["READY"] = "READY";
    AiDraftStatus["FAILED"] = "FAILED";
    AiDraftStatus["DISCARDED"] = "DISCARDED";
})(AiDraftStatus || (AiDraftStatus = {}));
//# sourceMappingURL=ai-draft-status.enum.js.map